import _ from 'underscore';
import Backbone from 'backbone';



let guid = 0;

const listener = _.extend( {}, Backbone.Events );

export default class Channel {

    constructor(writerFn) {
        this.readers_ = {};
        this.closeHandlers_ = [];

        if (!writerFn)
            return;
            
        writerFn(
            message => !this.closed_ && this.write_( message ),
            () => this.close() );
    }

    // writerFn = (writeFn, ...eventArguments) => { ... writeFn( ... ); }
    static fromEvents(emitter, eventName, writerFn = (writeFn, ...eventArguments) => writeFn( ... eventArguments) ) {
        // todo stopListening
        return new Channel( writeFn =>
            listener.listenTo( emitter, eventName, (...eventArguments) => 
                writerFn( writeFn, ...eventArguments ) ) );
    }

    write_(message) {
        // todo: if (!this.closed_) ???
        Object.keys( this.readers_ )
            .map( id => this.readers_[id])
            .forEach( readerFn => readerFn( message ) );
    }

    forEach(readerFn) {
        this.readers_[guid] = readerFn;
        return guid++; 
    }

    // todo: dest to Channel
    dest(writeFn) {
        this.forEach( writeFn );
    }

    spawn(fn) {
        let readerId;
        // todo: if parent channel closed?
        const ch = new Channel( writeFn => 
            readerId = this.forEach( message => fn( message, writeFn ) ) );

        ch.end( () => delete this.readers_[readerId] );

        return ch;
    }

    // spawns new channels, each of them receives
    // only properties named by ...propNames from each message
    split(...propNames) {
        return propNames.map( propName => this.prop( propName ) ); 
    }

    merge(...channels) {
        // todo: if ...channels all closed
        channels.push( this );
        return new Channel( writeFn => 
            channels.forEach( ch => ch.dest( writeFn ) ) );
    }

    // converts [...] message into individual messages
    flatten() {
        return this.spawn( (message, writeFn) => {
            if (message instanceof Array)
                return message.forEach( m => writeFn( m ) );

            writeFn( message );
        } );
    }

    filter(filterFn) {
        return this.spawn( (message, writeFn) => {
            if (!!filterFn( message ))
                writeFn( message );
        } );
    }

    map(mapFn) {
        return this.spawn( (message, writeFn) => writeFn( mapFn( message ) ) );
    }

    prop(propName) {
        return this.spawn( (message, writeFn) => {
            if (propName in message)
                writeFn( message[propName] );
        } );
    }

    close() {
        if (this.closed_)
            return;

        this.closeHandlers_.forEach( fn => fn() );

        // todo: close readers if those are channels
        this.closed_ = true;
        this.readers_ = {};
        this.closeHandlers_ = [];
    }

    end(handleFn) {
        if (this.closed_)
            return handleFn(), undefined;
            
        this.closeHandlers_.push( handleFn );
    }

}


// WEBPACK FOOTER //
// ./src/js/utils/channel.js